import SwiperComponent from '../../views/swiper/base/swiper'
import HamburgerComponent from '../../views/hamburger/hamburger'
import AccordianComponent from '../../views/accordian/base/accordian'
import StoreLocatorComponent from '../../views/store-locator/store-locator'
import HeaderComponent from '../../views/header/header'
import ParallaxComponent from './parallax'
import HeroComponent from '../../views/hero/hero'
 

const components = {
  SwiperComponent,
  HamburgerComponent,
  AccordianComponent, 
  StoreLocatorComponent,
  HeaderComponent,
  ParallaxComponent,
  HeroComponent
}

export default components;